import { Component } from 'react';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import DatePickerSection from 'MeetingsLib/components/sections/DatePickerSection';
import TimeOptionsSection from 'MeetingsLib/components/sections/TimeOptionsSection';
import PropertyFormV2 from 'MeetingsLib/components/sections/PropertyFormV2';
import { StickyFooter } from 'foundations-components/transitional/components/StickyFooter';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/components/View';
import FreemiumBookingUpgradeLink from 'MeetingsLib/components/freemium/FreemiumBookingUpgradeLink';
import { getPaidMeetingsAvailableSelector, getPaymentLinkInfo } from 'MeetingsLib/selectors/BookInfoSelectors';
import { getRecaptchaEnabled } from 'MeetingsLib/selectors/BookInfoSelectors';
import PaymentForm from '../payments/PaymentIframe';
import ErrorBoundary from '../ErrorBoundary';
import EmailFormV2 from '../sections/EmailFormV2';
import CookieSettingsLink from '../internalCompliance/CookieSettingsLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class CompactBookingPage extends Component {
  constructor(props) {
    super(props);
    this.renderEmailFormStep = () => {
      const {
        branding,
        welcomeScreenInfo,
        meetingChangeId,
        EmailFormMarker
      } = this.props;
      return /*#__PURE__*/_jsx(EmailFormV2, {
        branding: branding,
        compact: true
        /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */,
        logoUrl: welcomeScreenInfo.logoUrl,
        meetingChangeId: meetingChangeId
        /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */,
        title: welcomeScreenInfo.title,
        useCompanyLogo: welcomeScreenInfo.useCompanyLogo
        /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */,
        description: welcomeScreenInfo.description,
        EmailFormMarker: EmailFormMarker
      });
    };
    this.renderDatePickerStep = () => {
      const {
        avatar,
        companyAvatar,
        branding,
        displayAvatarOption,
        headline,
        profile,
        DatePickerMarker,
        TimePickerMarker
      } = this.props;
      return /*#__PURE__*/_jsx(DatePickerSection, {
        avatar: avatar,
        companyAvatar: companyAvatar,
        branding: branding,
        displayAvatarOption: displayAvatarOption,
        compact: true,
        headline: headline,
        profile: profile,
        DatePickerMarker: DatePickerMarker,
        TimePickerMarker: TimePickerMarker
      }, "compact-date");
    };
    this.renderTimeOptionsStep = () => {
      const {
        branding,
        isSalesStarter,
        profile,
        isFetchingPublicAvailability,
        resetEventDate,
        TimePickerMarker
      } = this.props;
      const reserveBrandingFooterSpace = !isSalesStarter;
      return /*#__PURE__*/_jsx(View, {
        paddingBlockEnd: reserveBrandingFooterSpace ? '1500' : '0',
        children: /*#__PURE__*/_jsx(TimeOptionsSection, {
          branding: branding,
          compact: true,
          goToPreviousStep: resetEventDate,
          isFetchingPublicAvailability: isFetchingPublicAvailability,
          profile: profile,
          TimePickerMarker: TimePickerMarker
        }, "compact-time")
      });
    };
    this.renderPropertyFormStep = () => {
      const {
        branding,
        canSubmitInitialPropertyForm,
        submittingMeeting,
        resetEventDateTime
      } = this.props;
      return /*#__PURE__*/_jsx(PropertyFormV2, {
        branding: branding,
        canSubmitInitialPropertyForm: canSubmitInitialPropertyForm,
        goToPreviousStep: resetEventDateTime,
        submittingMeeting: submittingMeeting,
        compact: true
      }, "compact-property");
    };
    this.renderPaymentForm = () => {
      const {
        resetFormState,
        resetConsentResponses,
        branding,
        submittingMeeting,
        recaptchaEnabled
      } = this.props;
      return /*#__PURE__*/_jsx(ErrorBoundary, {
        children: /*#__PURE__*/_jsx(PaymentForm, {
          goToPreviousStep: () => {
            resetFormState();
            resetConsentResponses();
          },
          branding: branding,
          compact: false,
          submittingMeeting: submittingMeeting,
          recaptchaEnabled: recaptchaEnabled
        }, "payment-form")
      });
    };
    this.renderCurrentStep = () => {
      const {
        shouldShowEmailForm,
        bookingLifecycle,
        emailFormState
      } = this.props;
      if (shouldShowEmailForm && !emailFormState) {
        return this.renderEmailFormStep();
      }
      if (!bookingLifecycle.event.dateString) {
        return this.renderDatePickerStep();
      }
      if (!bookingLifecycle.event.dateTime) {
        return this.renderTimeOptionsStep();
      }
      return this.renderPropertyFormStep();
    };
    this.renderCurrentStepWithPayments = () => {
      const {
        shouldShowEmailForm,
        bookingLifecycle,
        emailFormState,
        formState,
        legalConsentValid
      } = this.props;
      if (shouldShowEmailForm && !emailFormState) {
        return this.renderEmailFormStep();
      }
      if (!bookingLifecycle.event.dateString) {
        return this.renderDatePickerStep();
      }
      if (!bookingLifecycle.event.dateTime) {
        return this.renderTimeOptionsStep();
      }
      if (!formState || !legalConsentValid) {
        return this.renderPropertyFormStep();
      }
      return this.renderPaymentForm();
    };
    this.getContainerProps = () => {
      const {
        embedded
      } = this.props;
      return {
        direction: 'column',
        maxInlineSize: '400px',
        // compact-container max-width
        minInlineSize: '300px',
        // compact-container min-width ($min-card-width)
        marginInline: 'auto',
        // m-x-auto (centering)
        inlineSize: '100%',
        // width-100
        minBlockSize: '0',
        // min-height-0 (important for flexbox)
        paddingBlockStart: '400',
        // p-top-4
        blockSize: !embedded ? '100%' : undefined,
        // height-100 when not embedded, natural sizing when embedded
        maxBlockSize: embedded ? '100vh' : undefined // Prevent excessive growth in embedded mode
      };
    };
    this.state = {
      doTransition: false
    };
  }
  componentDidUpdate(prevProps) {
    const selectedDate = this.props.bookingLifecycle.event.dateString;
    const selectedTime = this.props.bookingLifecycle.event.dateTime;
    const wasOnDatePickerStep = !prevProps.bookingLifecycle.event.dateString && selectedDate;
    const wasOnTimeOptionsSection = prevProps.bookingLifecycle.event.dateString && !selectedDate;
    const isOnTimeOptionsSection = wasOnDatePickerStep && !selectedTime;
    const isNewFormStep = this.props.currentStep && prevProps.currentStep !== this.props.currentStep;
    if ((isNewFormStep || isOnTimeOptionsSection || wasOnTimeOptionsSection) && !this.state.doTransition) {
      this.setState({
        doTransition: true
      });
    }
  }
  render() {
    const {
      bookingLifecycle,
      isPaidMeeting,
      isSalesStarter
    } = this.props;
    const containerProps = this.getContainerProps();
    const hasPickedDateTime = !!bookingLifecycle.event.dateTime;
    return /*#__PURE__*/_jsxs(TFlex, Object.assign({}, containerProps, {
      children: [/*#__PURE__*/_jsx(CSSTransition, {
        classNames: "step-animation",
        timeout: 500,
        in: this.state.doTransition,
        onEntered: () => {
          this.setState({
            doTransition: false
          });
        },
        exit: false,
        children: /*#__PURE__*/_jsx(View, {
          flexDirection: "column",
          inlineSize: "100%",
          minBlockSize: "0",
          blockSize: "100%",
          children: isPaidMeeting ? this.renderCurrentStepWithPayments() : this.renderCurrentStep()
        })
      }), !isSalesStarter && !hasPickedDateTime ? /*#__PURE__*/_jsxs(StickyFooter, {
        children: [/*#__PURE__*/_jsx(FreemiumBookingUpgradeLink, {}), /*#__PURE__*/_jsx(CookieSettingsLink, {})]
      }) : /*#__PURE__*/_jsx(CookieSettingsLink, {
        includeFooterWrapper: true
      })]
    }));
  }
}
export default connect(state => ({
  isSalesStarter: state.isSalesStarter,
  isRescheduling: state.isRescheduling,
  meetingChangeId: state.meetingChangeId,
  isPaidMeeting: getPaidMeetingsAvailableSelector(state),
  paidMeetingInfo: getPaymentLinkInfo(state),
  /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
  recaptchaEnabled: getRecaptchaEnabled(state)
}), FormActions)(CompactBookingPage);